<template>
  <div v-loading="listLoading">
    <div v-show="propsObj.link" class="search-result">
      <div><span class="result-title">{{ wd |titleFilter }}</span> - 资源</div>
    </div>
    <div v-if="dataList && dataList.length>0" class="resoursList">
      <!-- <ul class="metu-item">
      <li class="active">
        最新上传
      </li><li>浏览最高</li><li>评分最高</li>
    </ul> -->
      <div v-for="(item, index) in dataList" :key="index" class="card-box" @click="openWindow(item)">
        <div class="list-item" @click="handlerLink">
          <div class="imgbox">
            <img :src="item.fileType | fileTypeFormat" class="imgsrc">
          </div>
          <div class="text">
            <div class="title">
              {{ item.title }}
              <!-- <span class="right">
                <img class="star" src="@/assets/img/ok-star.png" alt="">
                <img class="star" src="@/assets/img/ok-star.png" alt="">
                <img class="star" src="@/assets/img/ok-star.png" alt="">
                <img class="star" src="@/assets/img/ok-star.png" alt="">
                <img class="star" src="@/assets/img/no-star.png" alt="">
                <span class="branch">3.2分</span>
              </span> -->
            </div>
            <div class="docs-box">
              <span v-if="item.intro" class="intro">{{ item.intro | introFormat }}</span>
              <span class="date">
                {{ item.shareDate }}
              </span>
            </div>
            <p class="footer">
              <span>文件大小：{{ item.fileSize | mbFormat }} M</span><span>文件类型：{{ item.fileType }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <global-empty
      v-else
      :label="`暂无数据~`"
      link-it="3"
      height="200"
    />
    <pagination
      v-show="propsObj.link"
      :total="searchForm.total"
      :page.sync="searchForm.pageNum"
      :limit.sync="searchForm.pageSize"
      @pagination="pageCurriculumList"
      @handleSizeChange="handleSizeChange"
    />
  </div>
</template>
<script>
import { getAppList } from '@/api/search';
import ENVIRONMENT from '@/utils/environment';
import { getToken } from '@/utils/storage'; // getToken from cookie

export default {
  name: 'TabListResoure',
  filters: {
    introFormat(val) {
      if (!val) {
        return '';
      }
      return val;
    },
    mbFormat(val) {
      if (!val) {
        return '';
      }
      return (val / (1024 * 1024)).toFixed(1);
    },
    fileTypeFormat(val) {
      switch (val) {
        case 'pptx':
          return require('@/assets/img/ppt.png');
        case 'ppt':
          return require('@/assets/img/ppt.png');
        case 'doc':
          return require('@/assets/img/doc.png');
        case 'docx':
          return require('@/assets/img/doc.png');
        case 'xls':
          return require('@/assets/img/xls.png');
        case 'xlsx':
          return require('@/assets/img/xls.png');
        case 'txt':
          return require('@/assets/img/txt.png');
        case 'zip':
          return require('@/assets/img/zip.png');
        case 'rar':
          return require('@/assets/img/zip.png');
        case 'video':
          return require('@/assets/img/video.png');
        case 'mp4':
          return require('@/assets/img/video.png');
        case 'avi':
          return require('@/assets/img/video.png');
        case 'mp3':
          return require('@/assets/img/mp3.png');
        case 'bmp':
          return require('@/assets/img/bmp.png');
        case 'cunw':
          return require('@/assets/img/cunw.png');
        case 'pic':
          return require('@/assets/img/pic.png');
        case 'png':
          return require('@/assets/img/pic.png');
        case 'jpg':
          return require('@/assets/img/pic.png');
        case 'jpge':
          return require('@/assets/img/pic.png');
        default:
          return require('@/assets/img/other.png');
      }
    }
  },
  props: {
    propsObj: {
      default: Object,
      type: Object
    },
    wd: {
      default: String,
      type: String
    },
    searchClick: {
      default: String,
      type: String
    }
  },
  data: () => {
    return {
      searchForm: {
        pageNum: 0,
        pageSize: 10,
        total: 0
      },
      listLoading: true,
      dataList: [],
      link: ''
    };
  },
  watch: {
    searchClick(val) {
      console.log('点击了:' + val);
      this.getList();
    },
    $route() {
      this.getList();
    }
  },
  mounted() {
    console.log('资源:' + this.wd);
    this.getList();
  },
  methods: {
    async getList() {
      this.listLoading = true;
      if (!this.propsObj.link) {
        this.searchForm.pageSize = 4; // 全部类型只查询四条
      }
      const params = {
        code: 'S02',
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize,
        q: this.wd
      };
      await getAppList(params).then(res => {
        this.dataList = res.data.S02.list;
        this.searchForm.total = res.data.S02.total;
        setTimeout(() => {
          var list = document.getElementsByClassName('resoursList');
          if (this.dataList.length < 1) {
            this.height = 150;
          } else if (list[0].offsetHeight) {
            this.height = list[0].offsetHeight - 50;
          }
          const data = {
            result: this.searchForm.total,
            height: this.height
          };
          this.listLoading = false;
          window.parent.postMessage(data, '*');
        }, 500);
      });
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.getList();
    },
    openWindow(item) {
      var token = getToken() || '';
      var resourceSource = item.resourceSource === null ? '' : item.resourceSource;
      window.open(ENVIRONMENT.resoureUrl + '/#/homeMain/detailPage?id=' + item.itemId + '&type=' + item.type + '&storehouse=course' + '&resourceSource=' + resourceSource + '&token=' + token);
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.getList();
    },
    handlerLink() {
    // this.$router.push('/'+this.propsObj.link+'/'+this.propsObj.propsId);
    }
  }
};
</script>
<style scoped lang="scss">
 .resoursList{
   padding: 20px 16px 0 16px;
   .metu-item li{
      display: inline-block;
      padding: 5px 20px;
      border-radius: 4px;
      &.active{
        background: #409EFF;
        color: #fff;
      }
   }
   .card-box{
     padding: 20px;
     margin-bottom: 2px;
     background: #F3FAFF;
     cursor: pointer;
   }
  .list-item {
    display: flex;
    .imgbox {
      width: 50px;
      height: 55px;
      border-radius: 0%;
      // border: 1px solid #999;
      .imgsrc {
        width: 45px;
        height: 55px;

      }
    }
    .text {
      flex: 1;
      margin-left: 20px;
      line-height: 30px;
      .title{
        height: 14px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #3E3E3E;
        line-height: 18px;
      }
      p{
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #787878;
      }
    }
  }
  span{
    // padding-right: 20px;
  }
}
.search-result{
  display: flex;
  justify-content: space-between;
  padding: 10px 0 0px 0;
  margin: 0 16px 0px 20px;
  font-weight: bold;
  font-size: 18px;
  div{
    font-size: 18px;
    color: #787878;
    font-weight: 500;
  }
  .result-title{
  font-weight: bold !important;
  font-size: 18px !important;
  }
  span{
    color: #0082F1;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
}
.el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover{
  box-shadow: none;
}
.el-card{
  border: none;
}
.star{
  width: 21px;
  height: 21px;
  margin-right: 6px;
}
.docs-box{
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #787878;
  position: relative;
  margin-top: 10px;
}
.intro{
  width: 820px;
  height: 30px;
  overflow:hidden; //超出的文本隐藏
	text-overflow:ellipsis; //溢出用省略号显示
	white-space:nowrap; //溢出不换行
}
.branch{
  font-size: 16px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #FFB601;
  line-height: 18px;
  margin-bottom: 10px;
}
.date{
  height: 12px;
  font-size: 14px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #989898;
  line-height: 18px;
  line-height: 30px;
  right: 0px;
  position: absolute;
}
.footer{
  span{
    margin-right: 20px;
  }
}
</style>
